<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Código QR Code' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col class="qr-pessoa remove-border">
        <div>
          <img [src]="foto | image:' '" class="image-extendido">
        </div>

        <ion-item>
          <ion-label style="display: flex; justify-content: center;">
            <div style="width: 60%;">
              <h3>
                {{nome}}
              </h3>
            </div>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-card>
      <div class="qrcode-div">
        <qrcode
        class="qrcode"
        [qrdata]="qrCode"
        [width]="256"
        [errorCorrectionLevel]="'M'"
        ></qrcode>
      </div>

      <ion-card-header class="container-text">
        <ion-item class="backgroud-text">
          <ion-label>
            <h3 class="text-check">
              {{'Leia o código com o celular' | translate}}
              <br>{{'para realizar o check-in' | translate}}
            </h3>
          </ion-label>
        </ion-item>
      </ion-card-header>
    </ion-card>
  </ion-grid>
</ion-content>